<div>
  <button
    pButton
    type="button"
    [outlined]="true"
    class="client-info-button w-full text-left flex items-stretch justify-between pr-0 rounded-lg overflow-hidden focus-visible:ring-2 focus-visible:ring-[var(--p-primary-color)]"
    [ngClass]="{
      'client-selected': selected,
      'client-highlighted': highlight,

    }"
    (click)="selectEmployee()"
  >
    <div
      class="text-left font-normal text-[inherit] text-base leading-normal w-full"
    >
      <div class="w-full flex justify-between">
        <div class="flex items-center gap-3 overflow-hidden">
          <p-avatar
            [label]="initials"
            shape="circle"
            [styleClass]="
              'bg-primary text-white font-medium' +
              (selected ? ' avatar-selected' : '')
            "
            [style]="{ flex: '0 0 auto', width: '2.5rem', height: '2.5rem' }"
            [pTooltip]="collapsed ?  avatarTooltip : undefined"
            tooltipPosition="right"
          ></p-avatar>
          <ng-template #avatarTooltip>
            {{ employeeInfo.firstName | capitalizeFirst  }} {{ employeeInfo.lastName | capitalizeFirst  }}
          </ng-template>
          @if(!collapsed) {
            <div class="flex flex-col min-w-0 overflow-hidden">
              <div class="client-info-wrapper">
                <div class="client-name truncate">
                  {{ employeeInfo.firstName | capitalizeFirst  }} {{ employeeInfo.lastName | capitalizeFirst  }}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </button>
</div>
